import { WatchmanFetch } from '../../../shared/utils/watchmanFetch';
import type { StaffMember, Role, CreateStaffPayload, UpdateStaffPayload } from '../types';

export const staffApi = {
  list: (): Promise<StaffMember[]> => WatchmanFetch.get('/users/staff'),
  create: (data: CreateStaffPayload): Promise<StaffMember> => WatchmanFetch.post('/users', data),
  update: (id: string, data: UpdateStaffPayload): Promise<StaffMember> => WatchmanFetch.patch(`/users/${id}`, data),
  delete: (id: string): Promise<void> => WatchmanFetch.del(`/users/${id}`),
};

export const rolesApi = {
  list: (): Promise<Role[]> => WatchmanFetch.get('/roles'),
};
